export function shuffleMissionQueue<T>(items: readonly T[], random: () => number = Math.random): T[] {
  const shuffled = [...items];
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
  }
  return shuffled;
}

export function nextMissionQueueIndex(currentIndex: number, queueLength: number): number | null {
  const nextIndex = currentIndex + 1;
  return nextIndex < queueLength ? nextIndex : null;
}
